import React, { useEffect, useState } from "react";
import {
  View,
  Text,
  SafeAreaView,
  ActivityIndicator,
  TouchableOpacity,
  Alert,
  Linking,
} from "react-native";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { If, Then, Else } from "react-if";
import { Picker } from "@react-native-picker/picker";
import { useIntl, FormattedMessage } from "react-intl";
import activesService from "../../services/activesService";
import HeaderTabs from "../../components/HeaderTabs";
import api from "../../services/api";
import styles from "./styles";

const AssetsOwnership = () => {
  const [assets, setAssets] = useState([]);
  const [selectedAsset, setSelectedAsset] = useState("all");
  const [loading, setLoading] = useState(true);
  const [isGenerating, setIsGenerating] = useState(false);

  const intl = useIntl();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = await AsyncStorage.getItem("JWT_TOKEN");
        if (!token) return;
        const ativosResponse =
          await activesService.getActivesWhereUserHasBalance(token);
        const ativos = ativosResponse.data.filter(
          (item) => parseFloat(item.balance) > 0
        );
        setAssets(ativos);
      } catch (err) {
        console.error("Erro ao buscar dados:", err);
        Alert.alert(
          intl.formatMessage({ id: "assetsOwnership.alert.error.title" }),
          intl.formatMessage({ id: "assetsOwnership.alert.error.loadData" })
        );
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [intl]);

  const handleEmitCertificate = async () => {
    setIsGenerating(true);

    try {
      const token = await AsyncStorage.getItem("JWT_TOKEN");
      if (!token) {
        Alert.alert(
          intl.formatMessage({ id: "assetsOwnership.alert.error.authTitle" }),
          intl.formatMessage({ id: "assetsOwnership.alert.error.authMessage" })
        );
        setIsGenerating(false);
        return;
      }

      const requestBody = { asset_id: selectedAsset };
      const response = await api.post("/statements", requestBody, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const { statement_uuid } = response.data;

      let certificateUrl = "";
      const currentUrl = window.location.href;

      if (currentUrl.includes("localhost")) {
        certificateUrl = `http://localhost:8080/statements/show/${statement_uuid}`;
      } else if (currentUrl.includes("homol.gpxecofi.com.br")) {
        certificateUrl = `https://api.homol.gpxecofi.com.br/statements/show/${statement_uuid}`;
      } else {
        certificateUrl = `https://api.gpxecofi.com.br/statements/show/${statement_uuid}`;
      }

      const supported = await Linking.canOpenURL(certificateUrl);
      if (supported) {
        await Linking.openURL(certificateUrl);
      } else {
        Alert.alert(
          intl.formatMessage({ id: "assetsOwnership.alert.success.title" }),
          `${intl.formatMessage({
            id: "assetsOwnership.alert.success.openUrlError",
          })}${certificateUrl}`
        );
      }
    } catch (error) {
      console.error(
        "Erro ao gerar extrato:",
        error.response?.data || error.message
      );
      const errorMessage =
        error.response?.data?.message ||
        intl.formatMessage({
          id: "assetsOwnership.alert.error.generateStatement",
        });
      Alert.alert(
        intl.formatMessage({ id: "assetsOwnership.alert.error.title" }),
        errorMessage
      );
    } finally {
      setIsGenerating(false);
    }
  };

  if (loading) {
    return (
      <SafeAreaView style={styles.centered}>
        <ActivityIndicator size="large" />
        <Text>{intl.formatMessage({ id: "assetsOwnership.loadingData" })}</Text>
      </SafeAreaView>
    );
  }

  return (
    <SafeAreaView style={styles.container}>
      <HeaderTabs
        title={intl.formatMessage({ id: "assetsOwnership.header.title" })}
        subtitle={intl.formatMessage({
          id: "assetsOwnership.header.subtitle",
        })}
      />
      <View style={styles.card}>
        <Text style={styles.titulo}>
          {intl.formatMessage({ id: "assetsOwnership.card.title" })}
        </Text>
        <Text style={styles.cardDescription}>
          <FormattedMessage id="assetsOwnership.card.description" />
        </Text>
        <If condition={assets.length > 0}>
          <Then>
            <>
              <Picker
                selectedValue={selectedAsset}
                onValueChange={(itemValue) => setSelectedAsset(itemValue)}
                style={styles.picker}
              >
                <Picker.Item
                  label={intl.formatMessage({
                    id: "assetsOwnership.picker.allAssets",
                  })}
                  value="all"
                />
                {assets.map((item) => (
                  <Picker.Item
                    key={item.id}
                    label={`${item.name_token}${intl.formatMessage({
                      id: "assetsOwnership.picker.balanceLabel",
                    })}${Math.floor(parseFloat(item.balance))}`}
                    value={String(item.id)}
                  />
                ))}
              </Picker>
              <TouchableOpacity
                style={styles.button}
                onPress={handleEmitCertificate}
                disabled={isGenerating}
              >
                <If condition={isGenerating}>
                  <Then>
                    <ActivityIndicator color="#fff" />
                  </Then>
                  <Else>
                    <Text style={styles.buttonText}>
                      {intl.formatMessage({
                        id: "assetsOwnership.button.emit",
                      })}
                    </Text>
                  </Else>
                </If>
              </TouchableOpacity>
            </>
          </Then>
          <Else>
            <View style={styles.noAssets}>
              <Text>
                {intl.formatMessage({ id: "assetsOwnership.noAssets" })}
              </Text>
            </View>
          </Else>
        </If>
      </View>
    </SafeAreaView>
  );
};

export default AssetsOwnership;
